import { render, staticRenderFns } from "./TeamJourney.vue?vue&type=template&id=36ec7c4f&scoped=true&"
import script from "./TeamJourney.vue?vue&type=script&lang=js&"
export * from "./TeamJourney.vue?vue&type=script&lang=js&"
import style0 from "./TeamJourney.vue?vue&type=style&index=0&id=36ec7c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec7c4f",
  null
  
)

/* custom blocks */
import block0 from "./TeamJourney.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports